import React from 'react';

import ShowAllCollapsible from '~/components/core/Molecules/Collapsible/ShowAllCollapsible';
import RichNoteText from '~/components/Notes/NoteContent/RichNoteText';
import type { NoteContentProps, NotePartProps } from '~/components/Notes/types';

import Text from '../../core/TextComponents/Text';

const GeneralNote: React.FC<NoteContentProps> = ({ note, isExpanded, onCollapseClick, isCollapsible, maxRows }) => {
  const isRichNote = note.is_rich_text && !!note.note_html;

  // A collapsed rich note shows its plain text, so its formatting is only reachable by expanding it,
  // even when that plain text fits on the clamped lines.
  return isCollapsible ? (
    <ShowAllCollapsible
      visibleLines={maxRows || 1}
      showAsInlineButton
      isOpen={isExpanded}
      onCollapseClick={onCollapseClick}
      alwaysShowToggle={isRichNote}
    >
      <GeneralNoteInner note={note} isCollapsed={!isExpanded} />
    </ShowAllCollapsible>
  ) : (
    <GeneralNoteInner note={note} />
  );
};

interface GeneralNoteInnerProps extends NotePartProps {
  isCollapsed?: boolean;
}

const GeneralNoteInner: React.FC<GeneralNoteInnerProps> = ({ note, isCollapsed = false }) => {
  // A collapsed note shows its plain text: the line clamp that collapses it does not cut block
  // markup (lists, tables) at a line boundary.
  if (note.is_rich_text && note.note_html && !isCollapsed) {
    return <RichNoteText html={note.note_html} />;
  }

  return (
    <div className="whitespace-pre-line">
      <Text weight={Text.WEIGHTS.REGULAR} variant={Text.VARIANTS.SM}>
        {note.note_text}
      </Text>
    </div>
  );
};

export default GeneralNote;
